export function isValidMapCoordinate(value) {
  return (typeof value === 'number' || (typeof value === 'string' && value.trim() !== ''))
    && Number.isFinite(Number(value));
}

export function isValidMapPosition(destination) {
  return isValidMapCoordinate(destination?.latitude) && isValidMapCoordinate(destination?.longitude)
    && Number(destination.latitude) >= -90 && Number(destination.latitude) <= 90
    && Number(destination.longitude) >= -180 && Number(destination.longitude) <= 180;
}

export function buildGoogleMapsNavigationUrl(destination) {
  if (!isValidMapPosition(destination)) return null;
  const latitude = Number(destination?.latitude);
  const longitude = Number(destination?.longitude);
  const url = new URL('https://www.google.com/maps/dir/');
  url.searchParams.set('api', '1');
  url.searchParams.set('destination', `${latitude},${longitude}`);
  url.searchParams.set('dir_action', 'navigate');
  return url.toString();
}
